module.exports = __webpack_public_path__ + "static/media/bindQQ1.15507747.png";